import { Number } from "components/Number";
import { ResponsiveBlock } from "components/ResponsiveBlock";
import { Button } from "components/shared/buttons/Button";
import { useForm } from "lib/form";
import { device, mq } from "lib/media-query";
import React from "react";
import { useCounts } from "services/search";
import styled from "styled-components";
import ArrowRight from "svg/arrow-right.svg";
import { Loading } from "components/shared/Loading";
import { LoaderWrapper } from "./LoaderWrapper";

const Container = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 78px;
    padding: 16px 8px;
    box-sizing: border-box;
    background-color: #ffffff;
    box-shadow: 0 -1px 5px 0 rgba(0, 0, 0, 0.3);
    z-index: 10;

    ${mq.from(device.TABLET_LANDSCAPE)`
    height: 94px;
    padding: 24px 0;
  `};
`;

const Buttons = styled.div`
    display: grid;
    grid-template-columns: auto auto auto;
    gap: 8px;

    ${mq.from(device.TABLET_LANDSCAPE)`
    grid-template-columns: auto 150px 270px;
    gap: 16px;
  `};
`;

const StyledButton = styled(Button)`
    margin: 0;
`;

export const FixedBottomBar = ({ onCancel: cancel }) => {
    const [counts] = useCounts(true);
    const [submit, isSubmitting] = useForm();

    return (
        <Container>
            <ResponsiveBlock>
                <Buttons>
                    <div />
                    <StyledButton secondary size="big" alignIcon="right" onClick={cancel}>
                        Annuleer
                    </StyledButton>
                    <StyledButton
                        size="big"
                        alignIcon="right"
                        disabled={isSubmitting}
                        onClick={submit}
                    >
                        Bekijk {counts?.total ? <Number value={counts.total} /> : "de"} resultaten{" "}
                        {isSubmitting ? (
                            <LoaderWrapper>
                                <Loading />
                            </LoaderWrapper>
                        ) : (
                            <ArrowRight />
                        )}
                    </StyledButton>
                </Buttons>
            </ResponsiveBlock>
        </Container>
    );
};
